import { MRT_ColumnDef } from 'mantine-react-table';
import { Statement } from 'interfaces';
import { DatePickerInput } from '@mantine/dates';
import { Badge, NumberFormatter } from '@mantine/core';
import { useState } from 'react';
import { compareDateAsc, formatDateOnly } from 'utils/dateUtils';

export const StatementColumns = (showProviderColumn = false, sites = []) => {
  const columns: MRT_ColumnDef<Statement>[] = [
    ...(showProviderColumn
      ? [
          {
            id: 'provider',
            header: 'Provider',
            accessorFn: (row: Statement) =>
              [row.provider?.firstName, row.provider?.lastName]
                .filter(Boolean)
                .join(' '),
            Cell: ({ row }: { row: { original: Statement } }) =>
              [
                row.original.provider?.firstName,
                row.original.provider?.lastName,
              ]
                .filter(Boolean)
                .join(' '),
          },
        ]
      : []),
    {
      accessorKey: 'startDate',
      header: 'Start Date',
      sortingFn: (rowA, rowB, columnId) =>
        compareDateAsc(
          rowA.getValue<string>(columnId),
          rowB.getValue<string>(columnId)
        ),

      accessorFn: (row) => formatDateOnly(row?.startDate),
      Edit: ({ row }) => {
        const [startDate, setStartDate] = useState<string | null>(null);
        const handleDateChange = (date: string | null) => {
          setStartDate(date);
          row._valuesCache.startDate = date;
        };

        return (
          <DatePickerInput
            label="Start Date"
            value={startDate}
            onChange={handleDateChange}
          />
        );
      },
    },
    {
      accessorKey: 'endDate',
      header: 'End Date',
      accessorFn: (row) => formatDateOnly(row?.endDate),
      Edit: ({ row }) => {
        const [endDate, setEndDate] = useState<string | null>(null);

        const handleDateChange = (date: string | null) => {
          setEndDate(date);
          row._valuesCache.endDate = date;
        };

        return (
          <DatePickerInput
            label="End Date"
            value={endDate}
            onChange={handleDateChange}
          />
        );
      },
    },
    {
      accessorKey: 'totalAmount',
      header: 'Total Amount',
      Cell: ({ row }) => {
        const numericTotal = Number(row.original.totalAmount);
        return (
          <NumberFormatter
            value={numericTotal.toFixed(2)}
            prefix="$"
            thousandSeparator
            style={{ fontWeight: 'bold' }}
          />
        );
      },
      Edit: () => null,
    },
    {
      accessorKey: 'siteID',
      header: 'Site',
      Cell: ({ cell }) => (
        <Badge color="teal" variant="filled">
          {sites.find((site) => site.id === cell.getValue())?.name}
        </Badge>
      ),
    },
  ];

  return columns;
};
